export const getOS = (): string => {
  const userAgent = window.navigator.userAgent;
  if (userAgent.indexOf('Win') !== -1) {
    return 'Windows';
  }
  if (userAgent.indexOf('Mac') !== -1) {
    return 'Mac';
  }
  if (userAgent.indexOf('Linux') !== -1) {
    return 'Linux';
  }
  if (userAgent.indexOf('Android') !== -1) {
    return 'Android';
  }
  if (userAgent.indexOf('like Mac') !== -1) {
    return 'iOS';
  }

  return 'Unknown';
};

/**
 * Detecta si el dispositivo es Android.
 */
export const isAndroid = (): boolean => {
  return getOS() === 'Android';
};

/**
 * Detecta si el navegador es Google Chrome o Microsoft Edge.
 */
export const isChromeOrEdge = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isChromium = /Chrome/i.test(userAgent);
  const isEdge = /Edg/i.test(userAgent);

  return isChromium || isEdge;
};

/**
 * Valida si el navegador es compatible.
 * Solo bloquea en Android: debe usar Chrome o Edge.
 * En cualquier otro sistema (iOS, desktop, etc.) deja pasar.
 */
export const isBrowserCompatible = (): boolean => {
  if (!isAndroid()) return true;
  return isChromeOrEdge();
};
